import * as yup from "yup"
export const editStudentSchema = yup.object().shape({
  name: yup.string().required("Name field is required"),
  email: yup
    .string()
    .email("Add a correct email")
    .required("Email field is required"),
  phone: yup.string().min(11, "Phone number must be at least 11 digits"),
  birthdate: yup.string().required("Birthdate is required"),
  country: yup.string().required("Country field is required"),
  gov: yup.string().required("Governorate field is required"),
  college: yup.string().required("College field is required"),
  photo: yup.mixed(),
  password: yup.string().min(8, "The password must be at least 8 characters"),
  password_confirmation: yup
    .string()
    .oneOf([yup.ref("password")], "Password Confirmation must match password"),
})
